import Api from '../Api';

import { url } from './config';
import { Class } from './types';

const api = new Api<Class>(url);

export default api;
